import { render, staticRenderFns } from "./eventCard.vue?vue&type=template&id=799fa6b4&"
import script from "./eventCard.vue?vue&type=script&lang=js&"
export * from "./eventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports